<template>
  <div class="avatar-cont">
    <label class="input-cont input-cont_small">
      <p v-if="label"
         class="label">
        {{label}}
      </p>
      <p v-else class="label">
        {{$t('popups.addRole.photo')}}
      </p>
      <input type="file"
              @change="addAvatar"
             accept="image/gif, image/jpeg, image/png">
      <div class="group-avatar-cont">
        <div class="img-wrap">
          <img-dummy v-if="!avatar"></img-dummy>
          <img v-if="avatar"
               :src="avatar" alt="">
        </div>
        <button type="button" class="edit-btn">
          <edit-icon :fill="'#fff'"></edit-icon>
        </button>
        <div class="text-wrap">
          <clip-icon class="clip-icon"></clip-icon>
          <div>
            <p class="name" v-if="fileName">
              {{fileName | trimName}}
            </p>
            <p class="name" v-else>
              {{$t('forms.uploadPhotoLabel')}}
            </p>
            <errors class="size"
                    :style="{color: error ? '#ED1C24' : '#505D6F', opacity: error ? 1 : .4}"
                    :type="'fileSize'"
                    min-length="1,5"></errors>
          </div>
        </div>
      </div>
    </label>
    <button type="button"
            @click="delAvatar"
            class="del-avatar">
      <del-icon></del-icon>
    </button>
  </div>
</template>

<script>
  import imgDummy from './Svg/imgDummy'
  import editIcon from './Svg/editIcon'
  import clipIcon from './Svg/clipIcon'
  import errors from './Forms/errors'
  import delIcon from './Svg/cart_control/delIcon'

  export default {
    name: 'uploadAvatar',
    props: {
      label: {
        type: String,
        required: false,
      }
    },
    components: {
      imgDummy,
      editIcon,
      clipIcon,
      errors,
      delIcon
    },
    data() {
      return {
        avatar: '',
        error: false,
        fileName: '',
      }
    },
    filters: {
      trimName(val) {
        if (val.length > 25) {
          return val.slice(0, 25) + '...'
        } else {
          return val
        }
      }
    },
    methods: {
      addAvatar(e) {
        const fileList = e.target.files;
        const thisFile = fileList[fileList.length - 1];
        let imgSize = '';
        if (thisFile) {
          imgSize = thisFile.size;
        };
        const maxSizeMB = 1572864;

        if (imgSize < maxSizeMB) {
          if (!!thisFile) {
            this.fileName = thisFile.name;
            let cntx = this;

            const reader = new FileReader();
            reader.onload = function (event) {
              const contents = event.target.result;
              cntx.avatar = contents;
            };

            reader.readAsDataURL(thisFile);
            this.$emit('upload', thisFile);
          }
        } else {
          this.error = true;
          setTimeout(() => this.error = false, 3000)
        }
      },
      delAvatar() {
        this.avatar = '';
        this.fileName = '';
        this.$emit('del');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-cont {
    display: flex;
    align-items: center;

    input {
      position: absolute;
      width: 0;
      height: 0;
      z-index: -9999;
      opacity: 0;
    }

    .group-avatar-cont {
      display: flex;
      align-items: center;
      position: relative;
    }

    .img-wrap {
      min-width: 64px;
      max-width: 64px;
      max-height: 64px;
      border-radius: 50%;
      border: 1px solid $lightBlue;
      min-height: 64px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;
      overflow: hidden;

      img {
        width: 100%;
        //max-width: 61px;
        //border-radius: 50%;
        height: auto;
        //max-height: 60px;
        //max-width: 60px;
        object-fit: cover;
      }
    }

    .edit-btn {
      position: absolute;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
      background: $lightBlue;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      bottom: 0;
      left: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      pointer-events: none;
    }

    .clip-icon {
      margin-right: 10px;
    }

    .text-wrap {
      width: 100%;
      display: flex;
      align-items: flex-start;
    }

    .name {
      font-family: $mm;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: $lightBlue;
    }

    .size {
      font-family: $mm;
      font-size: 12px;
      letter-spacing: .25px;
      color: $asphalt;
      opacity: .5;
    }

    .del-avatar {
      margin-left: auto;
      width: 24px;
      height: 24px;

      svg {
        width: 69%;
      }
    }
  }
</style>
